<template>
<div>
    <button type="submit" class="btn btn-primary btn-lg btn-block ">
        Submit
    </button>
    <button v-on:click="closeModals()" type="submit" class="btn btn-link btn-lg btn-block mt-3">
        Cancel
    </button>
</div>
</template>

<script>
export default {}
</script>
